var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "collapse" } }, [
    _c(
      "section",
      {
        class: { expanded: _vm.mainExpanded },
        attrs: {
          aside: _vm.asideDirection,
          level: _vm.level > 0 ? _vm.level : false,
          direction: _vm.direction
        }
      },
      [
        _vm.heading || _vm.subheading || _vm.header || _vm.subheader
          ? _c(
              "header",
              { on: { click: _vm.headerClick } },
              [
                _vm.heading || _vm.subheading || _vm.subheader
                  ? _c(
                      "div",
                      [
                        _vm.heading
                          ? [
                              _vm.level <= 1
                                ? _c(
                                    "h2",
                                    {
                                      class: _vm.headingClass,
                                      on: { click: _vm.headingClick }
                                    },
                                    [_vm._v(_vm._s(_vm.heading))]
                                  )
                                : _vm.level <= 2
                                ? _c(
                                    "h4",
                                    {
                                      class: _vm.headingClass,
                                      on: { click: _vm.headingClick }
                                    },
                                    [_vm._v(_vm._s(_vm.heading))]
                                  )
                                : _c(
                                    "h5",
                                    {
                                      class: _vm.headingClass,
                                      on: { click: _vm.headingClick }
                                    },
                                    [_vm._v(_vm._s(_vm.heading))]
                                  )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subheading
                          ? _c("p", [_vm._v(_vm._s(_vm.subheading))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.subheader
                          ? _c("div", [_vm._t("subheader")], 2)
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._t("header")
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.aside
          ? _c("aside", { class: { expanded: _vm.asideExpanded } }, [
              _vm.asideHeading
                ? _c(
                    "header",
                    {
                      on: {
                        click: function($event) {
                          _vm.asideExpanded = !_vm.asideExpanded
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.asideHeading) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("article", [_vm._t("aside")], 2)
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.direction === "column"
          ? _c("div", [_vm._t("default")], 2)
          : _vm.columns === 1
          ? _vm._t("default")
          : _c("column-group", { class: _vm.columnClass }, [
              _vm.col1 ? _c("div", [_vm._t("column-1")], 2) : _vm._e(),
              _vm._v(" "),
              _vm.col2 ? _c("div", [_vm._t("column-2")], 2) : _vm._e(),
              _vm._v(" "),
              _vm.col3 ? _c("div", [_vm._t("column-3")], 2) : _vm._e(),
              _vm._v(" "),
              _vm.col4 ? _c("div", [_vm._t("column-4")], 2) : _vm._e()
            ]),
        _vm._v(" "),
        _vm.error
          ? _c("message", { attrs: { message: _vm.error, type: "warning" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.footer ? _c("footer", [_vm._t("footer")], 2) : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }